module.exports = __webpack_public_path__ + "static/img/ramka_zielona.23922133.png";